import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The performance tab: scene debug counters, profiling and camera path recording. The page owns the state; this
 * component only renders it, so it is checked with the page.
 */
@Component({
  selector: 'section[viewer-stats-panel]',
  templateUrl: './viewer-stats-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerStatsPanelComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;
}
